<template>
<div class="chapter">
<div class="inner_page">
<h1 id="pgepubid00002">The Journal of</h1>
<h1 class="sigil_not_in_toc">Submarine Commander</h1>
<h1 class="sigil_not_in_toc">von Forstner<br/></h1>
<h3 class="sigilnotintoc1 sigil_not_in_toc">BY</h3>
<h3 class="sigilnotintoc1 sigil_not_in_toc"><span style="text-align: justify;">Freiherr von Georg-Günther Forstner</span></h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?00c74fc2